import alerts from "./alerts";
import prisms from "./prisms";
import sensors from "./sensors";
import visualization from "./visualization";
import * as consts from "./consts";

const initialState = {
  source: -1
};

const actions = {
  async initialize({ commit, dispatch, state }, source) {
    if (state.source !== source) {
      commit(consts.SET_SOURCE, source);
      await dispatch("common/alerts/initialize", null, { root: true });
      await dispatch("common/prisms/initialize", null, { root: true });
      await dispatch("common/sensors/initialize", null, { root: true });
      await dispatch("common/visualization/initialize", null, { root: true });
    }
  }
};

const mutations = {
  [consts.SET_SOURCE](state, source) {
    state.source = source;
  }
};

const getters = {
  needInitialize() {
    return true;
  }
};

export default {
  namespaced: true,
  modules: {
    alerts,
    prisms,
    sensors,
    visualization
  },
  state: initialState,
  actions,
  mutations,
  getters
};
